import { Table } from "@/components/ui/Table";
import { useEffect, useState } from "react";
import { Title } from "@/components/ui/Title.ts";
import { assistantApi } from "@/api/assistants.ts";
import { TgLogo } from "@/assets/Logos.tsx";
import { AssistantName, BotName } from "@/pages/styles/AssistantsPage.styles.ts";
import { IAssistant } from "@/types/assistants.ts";
import { TableItem } from "@/pages/logs/styles.ts";
import { useAppDispatch } from "@/hooks/redux.ts";
import { setCurrentAssistant } from "@/store/assistantSlice.ts";
import { Link } from "react-router-dom";

const TableHeaders = [
    { text: 'Наименование', value: 'name' },
    { text: 'Интеграции', value: 'integrations' },
    { text: 'Новые сообщения', value: 'messages' },
]

interface ITableItem {
    name: string;
    integrations: string;
    id: number;
    PictureURL: string;
    messages: string;
    assistant: IAssistant
}

export const LogsPage = () => {
    const [data, setData] = useState<Array<ITableItem>>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const dispatch = useAppDispatch();

    const getTableData = async () => {
        setIsLoading(true)
        const { data } = await assistantApi.getAll().finally(() => {
            setIsLoading(false)
        });
        if(data) {
            const mappedData = data.reduce((acc: Array<ITableItem>, i: IAssistant) => {
                const integration = i.Integrations && JSON.parse(i.Integrations)?.telegram;
                acc.push({
                    name: i.Name,
                    integrations: integration,
                    id: i.ID,
                    PictureURL: i.PictureURL,
                    messages: i.new_session_count === 0
                        ? 'Нет новых сообщений'
                        : `${i.new_session_count} от ${i.new_session_contact_count} клиентов`,
                    assistant: i
                });
                return acc;
            }, [] as Array<ITableItem>);
            setData(mappedData);
        }
    }

    useEffect(() => {
        getTableData();
    }, []);

    return (
        <div>
            <div style={{ marginBottom: '29px' }}>
                <Title>Логи</Title>
            </div>
            <Table<ITableItem> headers={TableHeaders} loading={isLoading} data={data} tableKey='id'>
                {({value, column, item}) => {
                    if(typeof value === 'string' || typeof value === 'number') {
                        if(column === 'name') {
                            return (
                                <TableItem>
                                    <AssistantName
                                        onClick={() => dispatch(setCurrentAssistant(item.assistant))}
                                        to= {`/dashboard/logs/${item.id}/assistant`}
                                    >
                                        {item.PictureURL ? (
                                            <img src={item.PictureURL} alt="" />
                                        ) : (
                                            <div style={{
                                                width: '25px',
                                                height: '25px',
                                                borderRadius: '50%',
                                                backgroundColor: 'rgb(217, 217, 217)'
                                            }} />
                                        )}
                                        <span style={{fontSize: '14px', fontWeight: '600', color: 'rgb(35, 88, 162)'}}>{value}</span>
                                    </AssistantName>
                                </TableItem>
                            )
                        }
                        if(column === 'integrations') {
                            if (value) {
                                return (
                                    <TableItem>
                                        <BotName>
                                            <TgLogo />
                                            <Link style={{ fontWeight: 400 }} to={`https://t.me/${value}`} target='_blank'>
                                                @{value}
                                            </Link>
                                        </BotName>
                                    </TableItem>
                                )
                            }
                            return (
                                <div style={{ lineHeight: '48px' }}>Нет интеграций</div>
                            )
                        }
                        return (
                            <TableItem>{value}</TableItem>
                        )
                    }}
                }
            </Table>
        </div>
    )
}
